<template>
  <div>
    <a-form-model class="ec-login-form switch-form" :model="form" :rules="rules" ref="loginForm" hideRequiredMark :colon="false" labelAlign="left">
      <!-- 用户名/手机号/邮箱 -->
      <a-form-model-item prop="userName" :label="$t('common_form_login_name_or_phone')" htmlFor="userName">
        <a-input v-model="form.userName" type="text" v-forlogin="'userName'"></a-input>
      </a-form-model-item>
      <!-- 右侧验证码 -->
      <a-form-model-item v-if="captcha" prop="imgCode" :label="$t('common_form_identifying_code')" htmlFor="imgCode">
        <a-input autoComplete="off" v-model="form.imgCode" :maxLength="4"  v-forlogin="'imgCode'">
          <span slot="suffix" style="width:56px;height:33px;background:rgb(253, 253, 253);">
            <a-spin v-if="imgCodeLoading" size="small" style="margin-left: 25px; margin-top: 9px;" />
            <img v-else :src="imgCodeData" style="cursor:pointer; width: 100%; height: 100%" @click="getImgCode" />
          </span>
        </a-input>
      </a-form-model-item>
      <!-- 密码 -->
      <a-form-model-item prop="password" :label="$t('common_form_login_pd')" htmlFor="password">
        <a-input-password v-model="form.password" type="password" v-forlogin="'password'" @keyup.13="onSubmit"></a-input-password>
      </a-form-model-item>
      <!-- 客户代码 -->
      <a-form-model-item prop="subjectCode" :label="$t('common_form_customer_code')" htmlFor="subjectCode" v-if="ERP1">
        <a-input v-model="form.subjectCode" v-forlogin="'subjectCode'" @keyup.13="onSubmit"></a-input>
      </a-form-model-item>
    </a-form-model>
    <div class="ec-login-remend" v-if="!ERP1">
      <a-checkbox class="login-form__checkbox" v-model="form.hasExpireTime">{{$t('common_login_five_auto_login5天')}}</a-checkbox>
      <div class="link" @click="$emit('to', 'backEmail')">{{$t('common_login_forget_password')}}</div>
    </div>
    <a class="ec-login-submit" :class="{'ec-login-submit__loading': submitLoading}" @click="onSubmit" @keyup.13="onSubmit">
      <a-spin v-if="submitLoading">
        <a-icon slot="indicator" type="loading" style="font-size: 24px;  color: #fff" spin />
      </a-spin>
      <span v-else >{{ $t('common_login_title') }}</span>
    </a>
    <!-- ec-login-submit__disable -->
    <!-- ec-login-submit__loading -->
    <div class="ec-login-agreement" v-if="!ERP1">
      <span>{{ $t('common_login_登录即表明您同意') }}</span>
      <a-button type="link" @click="$emit('agreement', 'agreementVisible')">{{ $t('common_login_ServiceAgreement') }}</a-button>
      <span>{{ $t('common_conj_and') }}</span>
      <a-button type="link" @click="$emit('agreement', 'policyVisible')">{{ $t('common_login_PrivacyPolicy') }}</a-button>
    </div>
    <!-- <div class="ec-login-platform">
      <div class="ec-login-platform-item" @click="otherLoginBtn('ding')">
        <icon-font type="gb-icon-dingding" />
        <div>{{ $t('common_login_钉钉登录') }}</div>
      </div>
      <div class="ec-login-platform-item" @click="otherLoginBtn('weChat')">
        <icon-font type="gb-icon-weixin" />
        <div>{{ $t('common_login_微信登录') }}</div>
      </div>
    </div> -->
    <!-- 水平居中 -->
    <div style="display: flex; justify-content: center; margin-top: 10px;">
      <template v-if="!ERP1">
        <!-- ERP1.0客户登录 -->
        <!-- <a-button type="primary" @click="ERP1 = true">
          <icon-font type="gb-icon-computer-o"></icon-font>
          {{ $t('common_login_erp1') }}
        </a-button> -->
        <!-- 垂直居中 -->
        <div style="margin: 1px;height: 30px;font-size:14px;font-weight:400; display: flex; align-items: center;">{{ $t('common_login_login_tip') }}</div>
        <a-button style="padding: 0 4px;" type="link" @click="$emit('to', 'register')">
          <!-- <icon-font type="gb-icon-account-circle-line"></icon-font> -->
          {{ $t('common_login_免费注册') }}
        </a-button>
      </template>
      <template v-else>
        <a-button style="margin: 0 auto" type="link" @click="ERP1 = false">
          <div>11111</div>
          {{ $t('common_login_return_login') }}
        </a-button>
      </template>
    </div>
  </div>
</template>

<script>
import { login } from '@/api/sso/user'
import { LoginCodeAvatar } from '@/api/sso/code'

import mixins from '../mixins'
import { debounce } from '@/utils/util'

export default {
  mixins: [mixins],
  data () {
    return {
      ERP1: false,
      form: {},
      submitLoading: false,
      captcha: false,
      imgCodeLoading: false,
      imgCode: '',
      imgCodeData: '',
      readonly: true
    }
  },
  computed: {
    rules () {
      return {
        userName: { required: true, message: this.$t('common_form_please_enter', [this.$t('common_form_login_name_or_phone')]), trigger: [] },
        password: { required: true, message: this.$t('common_form_please_enter', [this.$t('common_form_login_pd2')]), trigger: [] },
        subjectCode: { required: true, message: this.$t('common_form_please_enter', [this.$t('common_form_customer_code')]), trigger: [] },
        imgCode: { required: true, message: this.$t('common_form_please_enter', [this.$t('common_form_identifying_code')]), trigger: [] }
      }
    }
  },
  watch: {
    ERP1 (val) {
      if (!val) {
        this.form.subjectCode = undefined
      }
    }
  },
  methods: {
    onSubmit () {
      const source = process.env.VUE_APP_SOURCE
      const sourceSystem = this.ERP1 ? 'sso' : process.env.VUE_APP_SOURCE_SYSTEM

      this.$refs['loginForm'].validate((flag, errors) => {
        if (!flag) return this.$message.error(errors[Object.keys(errors)[0]][0].message)
        this.submitLoading = true
        this.$store.dispatch('ClearDateAfterLogout')
        login({
          ...this.form,
          sourceSystem,
          source
        }).then(({ lastSystemCode, serviceId }) => {
          this.$nextTick(() => {
            this.$emit('done', { lastSystemCode, serviceId })
          })
        }).catch(({ showVerifyCode, code, message }) => {
          this.captcha = showVerifyCode === 'show'
          // 登录Ip限制
          if (code === 'saas.sso.error.code.8011') {
            this.$confirm({
              title: this.$t('common_login_IP提醒'),
              content: message
            })
          }
          this.captcha && this.getImgCode()
        }).finally(() => {
          setTimeout(() => {
            this.submitLoading = false
          }, 500)
        })
      })
    },
    getImgCode () {
      this.imgCodeLoading = true
      debounce(() => {
        LoginCodeAvatar().then(({ data }) => {
          this.form.imgCodeKey = data.imgCodeKey
          this.imgCodeData = data.imgCodeData
        })
          .finally(() => {
            this.imgCodeLoading = false
          })
      }, 500)
    },

    otherLoginBtn (type) {
      if (type === 'ding') {
        let width = 500
        let height = 500
        let left = (screen.width / 2) - (width / 2)
        let top = (screen.height / 2) - (height / 2) - 100
        window.open('//' + window.location.host.replace(/proxy\./g, '') + '/#/ding-talk-bind?bindDingTalk=2', '钉钉扫码登录', `height=${height}, width=${width},top=${top}, left=${left}, toolbar=no,menubar=no,scrollbars=no, resizable=no,location=no, status=no`)
      } else {
        this.$emit('to', 'weChat')
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this.readonly = false
    }, 500)
  }
}
</script>

<style lang="less" scoped>
@color: #077BFC;

.ec-login {
  &-form {
    input {
      width: 100%;
    }
  }
  &-remend {
    display: flex;
    justify-content: space-between;
    color: #5D6C82;
  }
  &-submit {
    width: 100%;
    height: 55px;
    line-height: 55px;
    background: @color;
    color: #fff;
    display: flex;
    font-size: 18px;
    border-radius: 2px;
    justify-content: center;
    justify-items: center;
    align-items: center;
    margin: 30px auto 0 auto;
    transition: all 0.3s;
    &:hover {
      opacity: 0.8;
    }
    &__disable {
      background: #ddd;
      cursor: default;
    }
    &__loading {
      width: 55px;
      border-radius: 55px;
      background: fade(@color, 75%);
    }
  }
  &-agreement {
    margin-top: 20px;
    word-break: break-all;
    .@{ant-prefix}-btn-link {
      margin: 0;
      padding: 0;
      height: auto;
      line-height: unset;
    }
  }
  &-platform {
    display: flex;
    justify-content: center;
    &-item {
      margin: 32px 30px;
      text-align: center;
      cursor: pointer;
      white-space: nowrap;
      &:hover {
        color: @color;
      }
      .anticon {
        font-size: 40px;
        margin-bottom: 12px;
      }
    }
  }
  &-flexo {
    height: 32px;
    display: flex;
    justify-content: space-between;
    .@{ant-prefix}-btn-primary {
      background: #F3F7FB;
      border-radius: 16px;
      color: #5D6C82;
      border: none;
      .anticon {
        color: fade(#5D6C82, 50%);
      }
      &:hover, &:hover .anticon  {
        color: @color;
      }
    }
    .home-ant-btn{
      padding: 0;
    }
  }
}
</style>
